import type { RewardCardTypeDTO, RewardPurchasePayload } from '@/types'
import { request } from '@/utils/requests/request'

export async function purchaseReward({ rewardId, userEmail, countryCode }: RewardPurchasePayload): Promise<void> {
    const URL = '/api/v1/rewards/purchase'
    try {
        const { originalResponse } = await request(URL, {
            method: 'post',
            body: JSON.stringify({
                reward_id: rewardId,
                user_email: userEmail,
                country_code: countryCode,
            }),
        })
        if (!originalResponse.ok) {
            return Promise.reject(originalResponse.status)
        }
    } catch (error) {
        console.error({ URL, error })
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject(500)
    }
}

export async function getRewards(): Promise<RewardCardTypeDTO[]> {
    const URL = '/api/v1/rewards'
    try {
        const { originalResponse, data } = await request<RewardCardTypeDTO[]>(URL)

        if (!originalResponse.ok) {
            return Promise.reject(originalResponse.status)
        }

        return data
    } catch (error) {
        console.error({ URL, error })
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject(500)
    }
}
